import {SettingsIcon} from "@components/icons";
import {colorScheme, setColorScheme} from "@core/store/slices/appSlice";
import {language, setLanguage} from "@core/store/slices/i18nSlice";
import {translate} from "@util";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import {useThemeContext} from "@theme";
import {ChangeEvent} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Selectors} from "@core/store/selectors";
type Props = {
  open: boolean;
  onClose: () => void;
};

function Settings(props: Props) {
  const {open, onClose} = props;

  const dispatch = useDispatch();
  const {theme} = useThemeContext();

  const lang = useSelector(Selectors.locale);
  const colorScheme = useSelector(Selectors.colorScheme);

  const handleChangeLanguage = (e: ChangeEvent<HTMLInputElement>) => {
    const l = e.target.value as language;
    dispatch(setLanguage(l));
  };

  const handleChangeTheme = (e: ChangeEvent<HTMLInputElement>) => {
    const mode = e.target.value as colorScheme;
    dispatch(setColorScheme(mode));
  };

  return (
    <Dialog open={open} fullWidth maxWidth="xs" onClose={onClose}>
      <Stack direction="row" mt={2} justifyContent="center">
        <Box
          sx={{
            bgcolor: theme.palette.secondary.dark,
            width: "64px",
            borderRadius: "32px",
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}>
          <SettingsIcon
            fontSize="large"
            sx={{
              color: theme.palette.getContrastText(
                theme.palette.secondary.dark,
              ),
            }}
          />
        </Box>
      </Stack>
      <DialogTitle align="center">
        {translate("userActions.settings")}
      </DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <TextField
            label={translate("userActions.language")}
            select
            value={lang}
            variant="standard"
            onChange={handleChangeLanguage}>
            <MenuItem value="it">🇮🇹 Italiano</MenuItem>
            <MenuItem value="en">🇬🇧 English</MenuItem>
            <MenuItem value="es">🇪🇸 Español</MenuItem>
          </TextField>
          <TextField
            label={translate("userActions.theme")}
            select
            value={colorScheme}
            variant="standard"
            onChange={handleChangeTheme}>
            <MenuItem value="light">{`☀️ ${translate("userActions.light")}`}</MenuItem>
            <MenuItem value="dark">{`🌙 ${translate("userActions.dark")}`}</MenuItem>
            <MenuItem value="system">{`💻 ${translate("userActions.system")}`}</MenuItem>
          </TextField>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export {Settings};
